'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    aggregationType: 'NONE',
    valueType: 'TEXT'
};
module.exports = exports['default'];
//# sourceMappingURL=dataElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/dataElement.js
// module id = 416
// module chunks = 0